/* global window, document, grecaptcha */
/*
 * contactable 1.5 - jQuery Ajax contact form
 *
 * Copyright (c) 2009 Philip Beel (http://www.theodin.co.uk/)
 * Dual licensed under the MIT (http://www.opensource.org/licenses/mit-license.php)
 * and GPL (http://www.opensource.org/licenses/gpl-license.php) licenses.
 *
 * Revision: $Id: jquery.contactable.min.js 2012-05-26 $
 *
 */

const BrowserInfo = require('public/js/lib/browser-info');
const SessionStorage = require('public/js/lib/session-storage');

(function (a) {
	const browserInfo = BrowserInfo({ window, rp_app });
	a.fn.contactable = function (b) {
		// We don't want to show the tab on mobile devices or our mobile version
		// of the site.
		//if (isMobileDeviceRP()) return;

		var c = {
			url: 'mail.php',
			name: 'Your Name',
			email: 'Your Email',
			dropdownTitle: '',
			dropdownOptions: ['General', 'Order Inquiry', 'Suggestion', 'Website bug', 'Feature request'],
			message: 'Message',
			subject: 'A contactable message',
			submit: 'SEND',
			recievedMsg: 'Thank you for your message',
			notRecievedMsg: 'Sorry but your message could not be sent, try again later',
			disclaimer: 'Please feel free to get in touch, we value your feedback',
			hideOnSubmit: true,
			captchaEnabled: false,
			captchaSite: ''
		};
		var b = a.extend(c, b);
		const captchaEnabled = b.captchaEnabled;
		const captchaSite = b.captchaSite;
		return this.each(function () {

			if (SessionStorage.getItem('feedback-is-hidden')) {
				// If feedback-is-hidden value is set, don't render at all
				return;
			}

			function h(token) {
				a(c + '.holder').hide();
				a(c + '#loading').show();
				a.ajax({
					type: 'POST',
					url: b.url,
					dataType: 'json',
					data: {
						subject: b.subject,
						name: a(c + '#name').val(),
						email: a(c + '#email').val(),
						issue: a(c + '#dropdown').val(),
						message: a(c + '#message').val(),
						captchaResponse: token,
						metadata: {
							browser_info: browserInfo.getBasicInfo(),
							rp_info: browserInfo.getRpInfo(),
						},
					},
					success: function (d) {
						a(c + '#loading').css({
							display: 'none'
						});

						if (d.response === 'success') {
							a(c + '#callback').show().append(b.recievedMsg);
							if (b.hideOnSubmit === true) {
								a(c + '#contactForm').animate({
									dummy: 1
								}, 2e3).animate({
									marginLeft: '-=450px'
								}, 'slow');
								a(c + 'div#contactable_inner').animate({
									dummy: 1
								}, 2e3).animate({
									marginLeft: '-=447px'
								}, 'slow').animate({
									marginLeft: '+=5px'
								}, 'fast');
								a(c + '#overlay').css({
									display: 'none'
								});
							}
						} else {
							a(c + '#callback').show().append(b.notRecievedMsg);
							setTimeout(function () {
								a(c + '.holder').show();
								a(c + '#callback').hide().html('');
							}, 2e3);
						}
					},
					error: function (d) {
						a(c + '#loading').css({
							display: 'none'
						});
						a(c + '#callback').show().append(b.notRecievedMsg);
					}
				});
			}

			var c = '#' + this.id + ' ',
				d = '',
				e = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/,
				f = b.dropdownOptions.length,
				g;
			if (b.dropdownTitle) {
				d += '<p><label for="dropdown">' + b.dropdownTitle + ' </label><br /><select name="dropdown" id="dropdown" class="dropdown">';
				for (g = 0; g < f; g++) {
					d += '<option value="' + b.dropdownOptions[g] + '">' + b.dropdownOptions[g] + '</option>';
				}
				d += '</select></p>';
			}
			var captchaText = '';
			if (captchaEnabled) {
				captchaText = '<div id="contactable-captcha" class="g-recaptcha" data-sitekey="' + captchaSite + '" data-callback="getContactableCaptchaToken" data-size="invisible" data-badge="inline">';
			}

			a(this).html('<div id="contactable_inner"><div id="contactable_close"><a href="javascript:;">&times;</a></div></div><form id="contactForm" method="" action=""><div id="loading"></div><div id="callback"></div><div class="holder"><p><label for="name">' + b.name + '<span class="green"> * </span></label><br /><input id="name" class="contact validate" name="name" /></p><p><label for="email">' + b.email + ' <span class="green"> * </span></label><br /><input id="email" class="contact validate" name="email" /></p>' + d + '<p><label for="message">' + b.message + ' <span class="green"> * </span></label><br /><textarea id="message" name="message" class="message validate" rows="4" cols="30" ></textarea></p><p><input class="submit" type="submit" value="' + b.submit + '"/></p><p class="disclaimer">' + b.disclaimer + '</p></div>' + captchaText + '</form>');

			window.getContactableCaptchaToken = function(token) {
				h(token);
			}

			var toggleOn = function () {
				a(c + '#overlay').css({
					display: 'block'
				});
				a(c + '#contactable_inner').animate({
					marginLeft: '-=5px'
				}, '2000');
				a(c + '#contactForm').animate({
					marginLeft: '-=0px'
				}, '2000');
				a(c + '#contactable_inner').animate({
					marginLeft: '+=387px'
				}, '4000');
				a(c + '#contactForm').animate({
					marginLeft: '+=390px'
				}, '4000');
			};
			var toggleOff = function () {
				a(c + '#contactForm').animate({
					marginLeft: '-=390px'
				}, '4000');
				a(c + '#contactable_inner').animate({
					marginLeft: '-=387px'
				}, '4000').animate({
					marginLeft: '+=5px'
				}, '2000');
			};

			a(c + '#contactable_inner').on('click', function(evt) {
				evt.preventDefault();
				if(a(c).hasClass('open')) {
					toggleOff();
					a(c).removeClass('open');
				} else {
					toggleOn();
					a(c).addClass('open');
				}
			});

			a(c + '#contactable_close').on('click', function(evt) {
				evt.preventDefault();
				SessionStorage.setItem('feedback-is-hidden', true);
				rp$('#contactable').addClass('hidden closed');
			});
			//a(c + "div#contactable_inner").toggle(toggleOn, toggleOff);
			a(c + '#contactForm').submit(function () {
				var b = true,
					d;
				a(c + '#contactForm .validate').each(function () {
					a(this).removeClass('invalid');
				});
				a(c + '#contactForm .validate').each(function () {
					if (a(this).val().length < 2) {
						a(this).addClass('invalid');
						b = false;
					}
					if (!e.test(a(c + '#contactForm #email').val())) {
						a(c + '#contactForm #email').addClass('invalid');
						b = false;
					}
				});
				if (b === true) {
					if (captchaEnabled) {
						var captchaIndex = -1;
						a('.g-recaptcha').each(function (index) {
							if(a(this)[0].id === 'contactable-captcha') {
								captchaIndex = index;
							}
						});
						grecaptcha.execute(captchaIndex);
					} else {
						h('');
					}
				}
				return false;
			});
		});
	};
})(rp$);


const contactable = {};

contactable.attach = function(captchaEnabled, captchaSite) {
	const $contactable = rp$('#contactable');
	if ($contactable.length && typeof rp$.fn.contactable === 'function') {
		rp$('#contactable').contactable({
			url: '/ajax/user-submit-feedback',
			name: 'Your Name',
			email: 'Your Email',
			dropdownTitle: 'Type',
			dropdownOptions: ['General', 'Order Inquiry', 'Suggestion', 'Website bug', 'Feature request'],
			message : 'Message',
			submit : 'Send',
			recievedMsg : 'Thank you for your message',
			notRecievedMsg : 'Sorry but your message could not be sent, please try again later',
			disclaimer: 'Thank you for taking the time to share your feedback. We are always looking for ways to provide a better shopping experience.',
			hideOnSubmit: true,
			captchaEnabled: captchaEnabled,
			captchaSite: captchaSite
		});

		// Check for mobile widths and hide
		rp$(window).bind('resize', this.check_width_hide_feedback);
		this.check_width_hide_feedback();
	}
};

contactable.check_width_hide_feedback = function() {
	const width = rp$(window).width();
	const min_width_for_feedback = 1000;

	const $contactable = rp$('#contactable');
	if(width < min_width_for_feedback) {
		$contactable.addClass('hidden');
	} else {
		if(!$contactable.hasClass('closed')) {
			$contactable.removeClass('hidden');
		}
	}
};


module.exports = contactable;
